export default "__VITE_ASSET__DdA7b024__"